import React from 'react';
import styled from 'styled-components';
import { RESPONSIVE_BREAKPOINT } from '../../utils/constants';

interface AuthPageLayoutProps {
  children: React.ReactNode;
}

const PageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  background: #F3F4F6;
  gap: 16px;
  padding: 16px;
  
  @media (max-width: ${RESPONSIVE_BREAKPOINT}) {
    flex-direction: column;
    background: white;
    gap: 0;
    padding: 0;
  }
`;

const LeftPanel = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px;
  background: #F8FAFC;
  background-image: url("data:image/svg+xml,%3csvg width='694' height='992' viewBox='0 0 694 992' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg clip-path='url(%23clip0_432_77152)'%3e%3crect width='694' height='992' rx='24' fill='%23F8FAFC'/%3e%3cg opacity='0.4' filter='url(%23filter0_f_432_77152)'%3e%3cpath d='M412.559 687.936L858.693 782.919C866.45 784.57 869.289 794.163 863.681 799.771L517.568 1145.88C512.002 1151.45 502.485 1148.7 500.745 1141.02L400.725 699.928C399.11 692.809 405.42 686.416 412.559 687.936Z' fill='url(%23paint0_radial_432_77152)' fill-opacity='0.5'/%3e%3c/g%3e%3cg opacity='0.4' filter='url(%23filter1_f_432_77152)'%3e%3cpath d='M-92.4407 -246.064L353.693 -151.081C361.45 -149.43 364.289 -139.837 358.681 -134.229L12.5682 211.884C7.0022 217.45 -2.51455 214.701 -4.25526 207.024L-104.275 -234.072C-105.89 -241.191 -99.5801 -247.584 -92.4407 -246.064Z' fill='url(%23paint1_radial_432_77152)' fill-opacity='0.5'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cfilter id='filter0_f_432_77152' x='200.47' y='487.71' width='866.149' height='861.11' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e%3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e%3cfeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3e%3cfeGaussianBlur stdDeviation='100' result='effect1_foregroundBlur_432_77152'/%3e%3c/filter%3e%3cfilter id='filter1_f_432_77152' x='-304.53' y='-446.29' width='866.148' height='861.11' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e%3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e%3cfeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3e%3cfeGaussianBlur stdDeviation='100' result='effect1_foregroundBlur_432_77152'/%3e%3c/filter%3e%3cradialGradient id='paint0_radial_432_77152' cx='0' cy='0' r='1' gradientTransform='matrix(-331.454 -3.35899 42.0326 -390.958 867.719 744.935)' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%2367E8F9'/%3e%3cstop offset='1' stop-color='%232563EB'/%3e%3c/radialGradient%3e%3cradialGradient id='paint1_radial_432_77152' cx='0' cy='0' r='1' gradientTransform='matrix(-331.454 -3.35899 42.0326 -390.958 362.719 -189.065)' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%2367E8F9'/%3e%3cstop offset='1' stop-color='%232563EB'/%3e%3c/radialGradient%3e%3cclipPath id='clip0_432_77152'%3e%3crect width='694' height='992' rx='24' fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 16px;
  
  @media (max-width: ${RESPONSIVE_BREAKPOINT}) {
    display: none;
  }
`;

const WelcomeContent = styled.div`
  text-align: center;
  
  h1 {
    font-family: Inter;
    font-weight: 500;
    font-size: 36px;
    color: #000000 !important;
    margin: 0;
    line-height: 1.2;
    
    .brand-text {
      font-weight: 900 ;
      font-size: 48px;
      color: #2563EB;
      display: block;
    }
  }
  
  @media (max-width: ${RESPONSIVE_BREAKPOINT}) {
    h1 {
      font-size: 20px;
      
      .brand-text {
        font-size: 32px;
      }
    }
  }
`;

const MobileHeader = styled.div`
  display: none;
  
  @media (max-width: ${RESPONSIVE_BREAKPOINT}) {
    display: block;
    padding: 20px;
    background: white;
  }
`;

const MobileWelcomeCard = styled.div`
  background: #F8FAFC;
  background-image: url("data:image/svg+xml,%3csvg width='344' height='179' viewBox='0 0 344 179' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg clip-path='url(%23clip0_221463_109150)'%3e%3crect width='344' height='179' rx='24' fill='%23F8FAFC'/%3e%3cg opacity='0.4' filter='url(%23filter0_f_221463_109150)'%3e%3cpath d='M-49.8716 -52.107L164.924 -6.37635C172.681 -4.72483 175.521 4.86744 169.913 10.4755L3.27288 177.115C-2.29311 182.681 -11.8099 179.932 -13.5506 172.255L-61.7064 -40.1148C-63.3206 -47.2335 -57.011 -53.627 -49.8716 -52.107Z' fill='url(%23paint0_linear_221463_109150)'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cfilter id='filter0_f_221463_109150' x='-261.961' y='-252.333' width='634.811' height='632.384' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e%3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e%3cfeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3e%3cfeGaussianBlur stdDeviation='100' result='effect1_foregroundBlur_221463_109150'/%3e%3c/filter%3e%3clinearGradient id='paint0_linear_221463_109150' x1='-30.5' y1='-31' x2='143' y2='97' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%2367E8F9'/%3e%3cstop offset='1' stop-color='%232563EB'/%3e%3c/linearGradient%3e%3cclipPath id='clip0_221463_109150'%3e%3crect width='344' height='179' rx='24' fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 24px;
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
`;

const RightPanel = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px;
  background: white;
  border-radius: 16px;
  
  @media (max-width: ${RESPONSIVE_BREAKPOINT}) {
    flex: none;
    width: 100%;
    min-height: auto;
    padding: 0 20px 40px 20px;
    align-items: flex-start;
    border-radius: 0;
  }
`;

const ContentContainer = styled.div`
  width: 100%;
  max-width: 400px;
`;

const AuthPageLayout: React.FC<AuthPageLayoutProps> = ({ children }) => {
  return (
    <PageContainer>
      <LeftPanel>
        <WelcomeContent>
          <h1>
            Welcome to<br />
            <span className="brand-text">OSA</span>
          </h1>
        </WelcomeContent>
      </LeftPanel>

      <MobileHeader>
        <MobileWelcomeCard>
          <WelcomeContent>
            <h1>
              Welcome to<br />
              <span className="brand-text">OSA</span>
            </h1>
          </WelcomeContent>
        </MobileWelcomeCard>
      </MobileHeader>

      <RightPanel>
        <ContentContainer>
          {children}
        </ContentContainer>
      </RightPanel>
    </PageContainer>
  );
};

export default AuthPageLayout; 